var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70625 2.8725C9.38125 2.22292 8.70208 1.6975 7.86791 1.79042C7.12166 1.87333 6.01375 2.15083 5.25833 3.06083C4.48291 3.99542 4.19375 5.45292 4.78916 7.63667C5.425 9.96625 6.36916 12.2629 7.54291 14.1158C8.70791 15.9554 10.1429 17.4279 11.7892 17.9925C13.245 18.4917 14.3583 18.2833 15.1704 17.735C15.9537 17.2062 16.3837 16.4108 16.6062 15.86C16.8554 15.2433 16.6912 14.6012 16.3662 14.1279L15.1675 12.3846C14.9027 11.9994 14.5214 11.7091 14.0796 11.5564C13.6378 11.4036 13.1587 11.3964 12.7125 11.5358L11.0558 12.0537C11.0035 12.0717 10.9471 12.0739 10.8935 12.06C10.84 12.0462 10.7917 12.0169 10.7546 11.9758C10.0171 11.1121 9.19083 9.9075 8.96625 8.68833C8.95914 8.65577 8.96402 8.62174 8.98 8.5925C9.22375 8.18292 9.64291 7.71875 10.0604 7.3125C10.7675 6.62417 11.0354 5.53 10.5687 4.5975L9.70625 2.8725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.128bd0321d35aa87327f5688bd508bd8.svg";
export { ForwardRef as ReactComponent };